import React from 'react'
import { Checkbox, Container, Image, Table } from 'semantic-ui-react'

import add from '../../../assets/images/add.png'
import edit from '../../../assets/images/edit-gray.png'
import trash from '../../../assets/images/trashbin.png'
import { tr } from '../../../helpers/languages'
import Bubble from '../../common/bubble'
import openDescription from '../../../assets/images/eye-fuchsia.png'
import closedDescription from '../../../assets/images/eye-gray.png'

const AssignedExercises = (props) => {
    return (
        <Container className='assigned-exercises'>
            <div className='l4'>
                <Table fixed singleLine className='exercises'>
                    <Table.Body>
                        {
                            props.exercises.map((exercise, index) => {
                                return (
                                    <Table.Row
                                        key={`exercise${exercise.id}`}
                                        className={index === props.exercises.length - 1 ? 'last' : ''}
                                    >
                                        <Table.Cell className='name'>
                                            <span>{exercise.title}</span>
                                            {
                                                exercise.description && (
                                                    <Bubble
                                                        name='description'
                                                        position='top center'
                                                        openImage={openDescription}
                                                        closedImage={closedDescription}
                                                        title={tr('DESCRIPTION')}
                                                        text={exercise.description}
                                                    />
                                                )
                                            }
                                        </Table.Cell>
                                        <Table.Cell className='actions'>
                                            {
                                                exercise.custom && (
                                                    <Image
                                                        src={edit}
                                                        className='edit'
                                                        onClick={
                                                            (_e) => {
                                                                props.onEditCustomExercise(index)
                                                            }
                                                        }
                                                    />
                                                )
                                            }
                                            {
                                                exercise.custom && (
                                                    <Image
                                                        src={trash}
                                                        className='trash'
                                                        onClick={
                                                            (_e) => {
                                                                props.onDeleteCustomExercise(index)
                                                            }
                                                        }
                                                    />
                                                )
                                            }
                                        </Table.Cell>
                                        <Table.Cell className='assign'>
                                            <Checkbox
                                                checked={exercise.assigned}
                                                onChange={(_e) => { props.onToggleExercise(index) }}
                                            />
                                        </Table.Cell>
                                    </Table.Row>
                                )
                            })
                        }
                    </Table.Body>
                </Table>
            </div>
            <Table fixed singleLine className={`add-other-exercise ${props.exercises.length > 4 ? 'more' : ''}`}>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell className='name'>
                            {tr('ADD_OTHER')}
                        </Table.Cell>
                        <Table.Cell className='actions'/>
                        <Table.Cell className='add'>
                            <Image
                                src={add}
                                onClick={(_e) => { props.onAddCustomExercise() }}
                            />
                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        </Container>
    )
}

export default AssignedExercises



// WEBPACK FOOTER //
// ./src/components/participant-session/exercises/assigned-exercises.js